import { SettingsReadOnlyText } from 'modules/templateEditor/common';
import { InAppContentDefinition } from 'modules/graphql/types';
import { NegativeFill } from 'ui/icons';
import { InputText } from 'ui/inputs';
import { FormField } from 'ui/formField';
import { colors } from 'ui/theme';

import { getIsEditMode } from 'modules/templateEditor/common/utils';
import { useQueryParamContext } from 'modules/templateEditor/context/QueryParamContext';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { SETTINGS_DISPLAY_CONTENT } from '../../../constants';

type Props = {
  condition: boolean;
  field: string;
  label: string;
  value?: string;
  'data-test'?: string;
};

export const FontFormField = ({ condition, field, label, value, 'data-test': dataTest }: Props) => {
  const { view } = useQueryParamContext();
  const { isEditMode, liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const { ottPayload } = (liveTemplate?.mediumData || {}) as InAppContentDefinition;
  const isEditModeVisible = getIsEditMode(view, isEditMode);

  const hasError = value ? !value.includes('.ttf') : undefined;

  const ReadOnly = value ? (
    <SettingsReadOnlyText $hasError={hasError} isUnset={false} data-test={`${field}-font-uri`}>
      {hasError && <NegativeFill color={colors.red100} height={16} width={16} />}
      {value}
    </SettingsReadOnlyText>
  ) : (
    <SettingsReadOnlyText isUnset={true} data-test={`${field}-font-uri`}>
      {SETTINGS_DISPLAY_CONTENT.roku.fonts.unset}
    </SettingsReadOnlyText>
  );

  return condition ? (
    <FormField
      isHorizontalLayout
      labelText={label}
      helpText={isEditModeVisible && !hasError && SETTINGS_DISPLAY_CONTENT.roku.fonts.helpText}
      hasError={hasError}
      errorText={SETTINGS_DISPLAY_CONTENT.roku.fonts.error}
      data-test={dataTest}
    >
      {isEditModeVisible ? (
        <InputText
          id={`${field}-uri-text-editor`}
          data-test={`${field}-uri-text-editor`}
          onChange={(uri) =>
            setCurrentMediumField('ottPayload', {
              ...ottPayload,
              [field]: `${uri.length > 0 ? 'pkg://' : ''}${uri}`,
            })
          }
          value={value?.replace('pkg://', '') || ''}
          placeholder={SETTINGS_DISPLAY_CONTENT.roku.fonts.placeholder}
          width="100%"
          Prefix="pkg://"
          type="text"
        />
      ) : (
        ReadOnly
      )}
    </FormField>
  ) : null;
};
